import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { SIGNATORY_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const MAIN_SIGNATORY_WRITE = gql `
    ${SIGNATORY_FIELDS}
    mutation writeMainSignatory($dossierId: Long, $participant: SignatoryFormDtoInput!) {
      write_main_signatory(dossierId: $dossierId, participant: $participant) {
        ...SignatoryFields
      }
    }
  `;
export const useMainSignatoryWriteMutation = (options) => useMutation(MAIN_SIGNATORY_WRITE, options);
export const useMainSignatoryWriteMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: MAIN_SIGNATORY_WRITE, variables }));
};
